
import { Grid } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";

export const Spinner = ({ ...props}) => {
    return (
      <Grid container justifyContent="center" sx={{ py: 4,}}>
        <Grid item xs="auto">
          <CircularProgress />
        </Grid>
      </Grid>
    );

};